import {
  ArrowLeft,
  CaretRight,
  Envelope,
  Phone,
  User,
  X,
} from 'phosphor-react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMobileMenuOpen } from '../Actions/Navigation.action';
import SideMenu from './SideMenu';

const NavigationMobile = () => {
  const dispatch = useDispatch();
  const {
    mobileMenuOpen,
    contentLinks,
    mobileAdditionalLinks,
    myPagesLink,
    phone,
    email,
    logoUrl,
  } = useSelector((state) => state.navigation);
  const [currentLink, setCurrentLink] = useState();
  const [previousLink, setPreviousLink] = useState();

  useEffect(() => {
    if (mobileMenuOpen) {
      setCurrentLink(null);
    }
  }, [mobileMenuOpen]);

  const onLinkClick = (link) => {
    link.previousLink = previousLink;
    setPreviousLink(currentLink);
    setCurrentLink(link);
  };

  const onBackClick = () => {
    setPreviousLink(previousLink?.previousLink);
    setCurrentLink(previousLink);
  };

  const links = (currentLink?.links ?? contentLinks).filter(
    (l) => !l.rightAligned
  );

  const header = (
    <>
      {!currentLink && <img src={logoUrl} alt="Logo" />}
      {currentLink && (
        <div className="navigation-mobile__back" onClick={onBackClick}>
          <ArrowLeft size={20} /> Tillbaka
        </div>
      )}
    </>
  );

  const showFooter =
    !currentLink &&
    (phone || email || myPagesLink || mobileAdditionalLinks?.length > 0);

  return (
    <SideMenu
      from="left"
      id="navigation-mobile"
      open={mobileMenuOpen}
      onClosed={() => dispatch(setMobileMenuOpen(false))}
      header={header}
      className="side-menu--navigation-mobile"
      closeButton={
        <X size={24} cursor="pointer" className="side-menu__close-button" />
      }
    >
      <div className="navigation-mobile__links">
        {links.map((link) => (
          <MobileNavigationItem
            link={link}
            key={'mobile' + link.url + link.name}
            onClick={onLinkClick}
          />
        ))}
      </div>
      {showFooter && (
        <div className="navigation-mobile__footer">
          {myPagesLink && (
            <div className="navigation-mobile__footer-link">
              <a href={myPagesLink.href}>
                <User /> {myPagesLink.text}
              </a>
            </div>
          )}
          {phone && (
            <div className="navigation-mobile__footer-link">
              <a href={`tel:${phone}`}>
                <Phone /> {phone}
              </a>
            </div>
          )}
          {email && (
            <div className="navigation-mobile__footer-link">
              <a href={`mailto:${email}`}>
                <Envelope /> {email}
              </a>
            </div>
          )}
          {mobileAdditionalLinks?.length > 0 &&
            mobileAdditionalLinks.map((link) => (
              <div
                key={'mobile-additional' + link.url + link.name}
                className="navigation-mobile__footer-link"
              >
                <a href={link.url}>{link.name}</a>
              </div>
            ))}
        </div>
      )}
    </SideMenu>
  );
};

const MobileNavigationItem = ({ link, onClick }) => (
  <div className="navigation-mobile__link">
    <a href={link.url}>{link.name}</a>
    {link.links?.length > 0 && (
      <div
        className="navigation-mobile__next-level-button"
        onClick={() => onClick && onClick(link)}
      >
        <CaretRight size={20} />
      </div>
    )}
  </div>
);

export default NavigationMobile;
